// extracted by mini-css-extract-plugin
export default {"someHistory":"SomeHistory_someHistory__MJVci","col":"SomeHistory_col__eGAO8","title":"SomeHistory_title__sLo4N","text":"SomeHistory_text__uLzPq"};